// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/page-intro-article/page-intro-article.component.scss
// module id = 431
// module chunks = 0